function userFocus(element) {
  element.userFocus = true;
  element.focus();
  element.userFocus = false;
}

function hasUserFocus(element) {
  return !!element.userFocus;
}

function setUserFocus(element, value) {
  element.userFocus = value;
}

export { hasUserFocus as h, setUserFocus as s, userFocus as u };